var _rect, _rect2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOfflineBackground(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 335,
    height: 101,
    viewBox: "0 0 335 101",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_11449_46819",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 335,
    height: 101
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 335,
    height: 101,
    rx: 11,
    fill: "#E9F7EF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 334,
    height: 100,
    rx: 10.5,
    stroke: "url(#paint0_linear_11449_46819)",
    strokeOpacity: 0.2
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_11449_46819)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M264.755 100.987C279.474 99.2647 293.255 90.8883 301.236 77.0647L324.58 36.6326C326.369 33.5332 325.32 29.5721 322.238 27.7927L304.765 17.7048C309.095 7.58572 305.413 -4.38863 295.69 -10.0018C285.968 -15.615 273.757 -12.8166 267.16 -4.01058L249.688 -14.0984C246.606 -15.8778 242.65 -14.8061 240.861 -11.7067L217.517 28.7253C209.537 42.5482 209.172 58.6755 215.04 72.2803C194.532 68.9469 173.185 78.1911 162.242 97.1444C160.453 100.244 161.502 104.205 164.584 105.984L260.803 161.536C263.885 163.315 267.84 162.244 269.629 159.144C280.57 140.194 277.903 117.085 264.758 100.989L264.755 100.987ZM289.207 1.22733C293.545 3.73179 295.029 9.30157 292.519 13.6482C290.011 17.9917 284.444 19.4948 280.106 16.9904C275.769 14.4859 274.285 8.91613 276.794 4.56951C279.302 0.226017 284.869 -1.27713 289.207 1.22733ZM262.777 8.43088C262.521 16.2933 266.369 24.0381 273.62 28.2248C280.872 32.4116 289.502 31.8705 296.184 27.7185L310.173 35.795L299.603 54.1025L238.219 18.6624L248.789 0.354892L262.777 8.43088ZM228.685 35.1739L231.735 29.8904L293.119 65.3304L290.069 70.614C280.264 87.5962 258.521 93.4614 241.596 83.6899C224.675 73.9204 218.879 52.1556 228.684 35.1735L228.685 35.1739ZM177.128 98.2563C188.864 84.1608 209.548 80.1665 226.095 89.7201L244.129 100.132C260.673 109.683 267.554 129.589 261.22 146.807L177.128 98.2563Z",
    fill: "#EE960D",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("circle", {
    cx: -18,
    cy: -22,
    r: 114,
    fill: "#C79428",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: -18,
    cy: -22,
    r: 101.9,
    stroke: "url(#paint1_linear_11449_46819)",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.9 -22C73.9 28.755 32.755 69.9 -18 69.9C-68.755 69.9 -109.9 28.755 -109.9 -22C-109.9 -72.755 -68.755 -113.9 -18 -113.9C32.755 -113.9 73.9 -72.755 73.9 -22Z",
    stroke: "url(#paint2_linear_11449_46819)",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.9 -22C63.9 23.2321 27.2321 59.9 -18 59.9C-63.2321 59.9 -99.9 23.2321 -99.9 -22C-99.9 -67.2321 -63.2321 -103.9 -18 -103.9C27.2321 -103.9 63.9 -67.2321 63.9 -22Z",
    stroke: "url(#paint3_linear_11449_46819)",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.9 -22C52.9 17.157 21.157 48.9 -18 48.9C-57.157 48.9 -88.9 17.157 -88.9 -22C-88.9 -61.157 -57.157 -92.9 -18 -92.9C21.157 -92.9 52.9 -61.157 52.9 -22Z",
    stroke: "url(#paint4_linear_11449_46819)",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.9 -22C42.9 11.6341 15.6341 38.9 -18 38.9C-51.6341 38.9 -78.9 11.6341 -78.9 -22C-78.9 -55.6341 -51.6341 -82.9 -18 -82.9C15.6341 -82.9 42.9 -55.6341 42.9 -22Z",
    stroke: "url(#paint5_linear_11449_46819)",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.9 -22C32.9 6.11129 10.1113 28.9 -18 28.9C-46.1113 28.9 -68.9 6.11129 -68.9 -22C-68.9 -50.1113 -46.1113 -72.9 -18 -72.9C10.1113 -72.9 32.9 -50.1113 32.9 -22Z",
    stroke: "url(#paint6_linear_11449_46819)",
    strokeWidth: 0.2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_11449_46819",
    x1: -4.7111e-7,
    y1: 2.525,
    x2: 228.103,
    y2: 215.493,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#57B079"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C7EDD7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_11449_46819",
    x1: 71.5,
    y1: 38,
    x2: -70,
    y2: -22,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EAA02B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD595"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_11449_46819",
    x1: 62.7255,
    y1: 32.1176,
    x2: -64.902,
    y2: -22,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EAA02B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD595"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_11449_46819",
    x1: 53.951,
    y1: 26.2353,
    x2: -59.8039,
    y2: -22,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EAA02B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD595"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_11449_46819",
    x1: 44.299,
    y1: 19.7647,
    x2: -54.1961,
    y2: -22,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EAA02B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD595"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_11449_46819",
    x1: 35.5245,
    y1: 13.8823,
    x2: -49.098,
    y2: -22,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EAA02B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD595"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_11449_46819",
    x1: 26.75,
    y1: 7.99999,
    x2: -44,
    y2: -22,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EAA02B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD595"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOfflineBackground);
export default __webpack_public_path__ + "static/media/OfflineBackground.d319c176e1e039910d9a6915b4999f8f.svg";
export { ForwardRef as ReactComponent };